import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=dfb78648&scoped=true&"
import script from "./AppToolbar.vue?vue&type=script&lang=js&"
export * from "./AppToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AppToolbar.vue?vue&type=style&index=0&id=dfb78648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb78648",
  null
  
)

/* custom blocks */
import block0 from "./AppToolbar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports